// Dashboard tab registry for the web app.
//
// Intentionally kept out of `constants.ts`: that file is part of the worker and
// telegram image build filters (`.github/workflows/deploy.yml`), so changing it
// rebuilds and rolls those services. The dashboard's tabs are a web concern, so
// adding/removing one here (and in `web/`) must not trigger a fleet rollout.
export type DashboardTab =
  | "overview"
  | "whatsapp"
  | "telegram"
  | "facebook"
  | "linkedin"
  | "reddit"
  | "phone"
  | "billing"
  | "settings";

export const tabOrder: { key: DashboardTab; label: string }[] = [
  { key: "overview", label: "Overview" },
  { key: "whatsapp", label: "WhatsApp" },
  { key: "telegram", label: "Telegram" },
  { key: "facebook", label: "Facebook" },
  { key: "linkedin", label: "LinkedIn" },
  { key: "reddit", label: "Reddit" },
  { key: "phone", label: "Phone numbers" },
  { key: "billing", label: "Billing" },
  { key: "settings", label: "Settings" },
];
